import styled from 'styled-components'

export const OverlayLoaderContentStyled = styled.div`
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  text-align: center;
`
